import { Anchor as MAnchor } from '@mantine/core';
import classes from './anchor.module.scss';

export const Anchor = MAnchor.extend({
  classNames: classes,
});
